import {createSelector} from 'reselect';

const storeSettings = (store) => store.settings;

export const storeSettingsSelector = createSelector(
    storeSettings,
    (settings) =>  settings
)

export const storeBusinessHoursTemplatesSelector = createSelector(
    storeSettingsSelector,
    (settings) =>  settings.businessHourTemplatesData || []
)

export const storeActiveUserSelector = createSelector(
    storeSettingsSelector,
    (settings) =>  settings.accountUpgrade.activeUsers || 1
)

export const storeAvailablePlansSelector = createSelector(
    storeSettingsSelector,
    (settings) => settings.accountUpgrade.availablePlans || {}
)

export const storeFeatureAccessSelector = createSelector(
    storeSettingsSelector,
    (settings) => settings.accountDetails.features || {}
)

export const storeFooterTextSelector = createSelector(
    storeFeatureAccessSelector,
    (features) => features['email-footer']?.footer_text || ''
)

export const outOfOfficeSettingsSelector = createSelector(
    storeFeatureAccessSelector,
    (features) => features?.out_of_office
)